export function formatDuration(durationStr) {
  if (!durationStr) return "";
  // Handles formats like "00:03", "01:05:00", "00:00:02"
  const parts = durationStr.split(":").map(Number);
  let hours = 0, minutes = 0, seconds = 0;
  if (parts.length === 3) {
    [hours, minutes, seconds] = parts;
  } else if (parts.length === 2) {
    [minutes, seconds] = parts;
  } else if (parts.length === 1) {
    [minutes] = parts;
  }
  let result = [];
  if (hours) result.push(`${hours} hr${hours > 1 ? "s" : ""}`);
  if (minutes) result.push(`${minutes} min`);
  if (!hours && !minutes && seconds) result.push(`${seconds} sec`);
  return result.join(" ") || "0 min";
}